import React from 'react';
import { AdminDashboard } from '../../components/admin/Dashboard';
import { useAdminDashboard } from '../../hooks/useAdminDashboard';

export const DashboardPage: React.FC = () => {
  const dashboardProps = useAdminDashboard();

  return <AdminDashboard {...dashboardProps} />;
};
